import React, { useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { notification, theme } from 'antd';
import { HiDocumentText } from 'react-icons/hi';
import FormPublisher from '../../components/clinicalForms/FormPublisher.component';
import { createForm } from '../../actions/formActions';
import useDocumentTitle from '../../utils/useDocumentTitle';
import PageWrapper from '../../components/common/PageWrapper';

/**
 * Create Clinical Form Screen
 * Handles creation of new clinical forms using the publisher component
 */
const FormCreateScreen = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { token } = theme.useToken();
  const [searchParams] = useSearchParams();
  const defaultEntityType = searchParams.get('entityType');
  useDocumentTitle('Create Form');

  // Redux state variables
  const formCreate = useSelector((state) => state.formCreate);
  const { loading: loadingCreate, error: errorCreate, success: successCreate, form: createdForm } = formCreate;

  // Handle success - redirect to edit page
  useEffect(() => {
    if (successCreate && createdForm) {
      notification.success({ message: 'Form created successfully' });
      if (createdForm?.id) {
        navigate(`/settings/forms/edit/${createdForm.id}`);
      }
      dispatch({ type: 'FORM_CREATE_RESET' });
    }
  }, [successCreate, createdForm, navigate, dispatch]);

  const handleCreateForm = (payload) => {
    dispatch(createForm(payload));
  };

  return (
    <PageWrapper
      title="Create Form"
      icon={<HiDocumentText style={{ fontSize: 24, color: token.colorPrimary }} />}
    >
      <FormPublisher 
        formId={null}
        defaultEntityType={defaultEntityType}
        loadingCreate={loadingCreate}
        errorCreate={errorCreate}
        onCreateForm={handleCreateForm}
        showBackButton={false}
        showPadding={false}
      />
    </PageWrapper>
  );
};

export default FormCreateScreen;

